import { useSelector, } from 'react-redux';
import { useEffect, } from 'react';
import { actionFetchStatsReportWidgets, useAppDispatch, IReducerStore, } from '@Store';

let initiated = false;

export const useStatsReportWidgets = (autoload: boolean = true) => {
  const dispatch = useAppDispatch();
  const stats_report_widgets = useSelector((store: IReducerStore) => store.stats_report_widgets);

  useEffect(() => {
    if (!initiated && autoload && !stats_report_widgets.loaded && !stats_report_widgets.loading) {
      initiated = true;
      dispatch(actionFetchStatsReportWidgets());
    }
  }, [autoload, stats_report_widgets.loaded, stats_report_widgets.loading, dispatch, ]);

  return stats_report_widgets;
};
